import { useRuntimeVariables } from 'app-kit'
import { isPageMetadataCacheKey } from 'features/evaluations/metadata/utils/evalDataKeys'
import { useKnowledgeDocumentDataContext } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentDataContext'
import { useCallback } from 'react'
import { useSWRConfig } from 'swr'

/** Refresh page overlays and eval reports once for the affected site and organization. */
export function useInvalidateDocumentPageMetadataUserEditLoads(): () => Promise<void> {
  const { mutate } = useSWRConfig()
  const { ROLODEX_URL } = useRuntimeVariables()
  const { siteID, orgID } = useKnowledgeDocumentDataContext()
  return useCallback(async () => {
    await mutate(
      (key) => isPageMetadataCacheKey(key, ROLODEX_URL, siteID, orgID),
      undefined,
      { revalidate: true }
    )
  }, [ROLODEX_URL, mutate, siteID, orgID])
}
